{
  "contact-data-form": {
    "text": {
      "email": "E-Mail"
    }
  }
}
